/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { borderWidth: 3 } },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        borderColor: '#000000',
        iconColor: '#666666'
      }
    },
    { if: { focus: true }, tokens: { outerBorderColor: '#000000' } },
    {
      if: { focus: true, pressed: true },
      tokens: { borderWidth: 1, outerBorderColor: '#000000' }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: '#c9c8c8',
    borderRadius: 48,
    borderWidth: 1,
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    icon: null,
    iconColor: '#000000',
    iconSize: 24,
    iconSpace: 2,
    lineHeight: 1.5,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: '#ffffff',
    outerBorderGap: 2,
    outerBorderWidth: 2,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 12,
    shadow: null,
    textAlign: 'center',
    width: null
  }
}
export default theme
